import { Link } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";
import { SITE, LOCALITIES } from "@/config/site";
import { Seo } from "@/components/Seo";
import { Breadcrumbs, breadcrumbSchema } from "@/components/Breadcrumbs";
import { Reveal } from "@/components/Reveal";
import { FinalCTA, SectionHeading } from "@/components/blocks";

export default function Zones() {
  const crumbs = [{ label: "Zones d'intervention" }];
  return (
    <>
      <Seo
        title="Zones d'intervention dans la Manche (50) | FRELONS50"
        description="FRELONS50 intervient dans la Manche : Le Teilleul, Saint-Hilaire-du-Harcouët, Avranches, Granville, Coutances, Saint-Lô, Cherbourg-en-Cotentin et communes environnantes selon disponibilité."
        path="/zones-intervention"
        jsonLd={breadcrumbSchema(crumbs)}
      />
      <section className="max-w-7xl mx-auto px-4 md:px-8 pt-8 pb-4">
        <Breadcrumbs items={crumbs} />
      </section>
      <section className="max-w-7xl mx-auto px-4 md:px-8 pb-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-brand-black leading-[1.08]">
            Intervention dans la Manche
          </h1>
          <p className="mt-5 text-lg text-brand-text leading-relaxed">
            Nous intervenons dans le département de la Manche (50) et les communes limitrophes, selon disponibilité, contre
            les frelons, guêpes, rats, souris et autres nuisibles.
          </p>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {LOCALITIES.map((t) => (
              <Link key={t.slug} to={`/zone/${t.slug}`} data-testid={`zone-link-${t.slug}`} className="inline-flex items-center gap-1.5 bg-white border border-gray-200 shadow-sm px-4 py-2 rounded-full text-sm font-medium text-brand-black hover:border-brand-gold hover:-translate-y-0.5 transition-all">
                <MapPin className="w-3.5 h-3.5 text-brand-gold" /> {t.name}
              </Link>
            ))}
            <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium text-brand-text">
              …et communes environnantes selon disponibilité
            </span>
          </div>
          <div className="mt-8 bg-brand-gray rounded-2xl p-6">
            <p className="text-brand-black font-semibold">Votre commune n'est pas indiquée ?</p>
            <p className="text-sm text-brand-text mt-1 mb-4">Contactez-nous pour vérifier notre disponibilité dans votre secteur.</p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a href={SITE.phoneHref} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-brand-gold text-brand-black font-bold text-sm"><Phone className="w-4 h-4" /> Appeler</a>
              <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border-2 border-brand-black text-brand-black font-bold text-sm">Vérifier ma commune</Link>
            </div>
          </div>
        </div>
        <Reveal className="flex justify-center">
          <img src="/images/manche-map.png" alt="Carte du département de la Manche" className="w-full max-w-md" width="500" height="500" />
        </Reveal>
      </section>
      <FinalCTA />
    </>
  );
}
